import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => {
  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="currentColor" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        id="Line"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5908 15.3537C28.0964 15.8229 28.0993 16.5809 28.5972 17.0468L32.8078 20.986H8.77055C8.06884 20.986 7.5 21.522 7.5 22.1832C7.5 22.8444 8.06884 23.3804 8.77055 23.3804H33.2382L27.7682 27.9029C27.2407 28.339 27.1883 29.0954 27.6511 29.5924C28.1139 30.0894 28.9167 30.1388 29.4441 29.7027L37.0674 23.3999C37.6207 22.9424 37.647 22.1391 37.1246 21.6504L30.3876 15.3476C29.8897 14.8818 29.0852 14.8845 28.5908 15.3537Z"
        fill="currentColor"
      />
    </svg>
  );
};

const IconMoveRight: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;
export interface IIconMoveRight extends IIcon {}

export default IconMoveRight;
